/**
 * Font Awesome Formatter.
 */
window.fontAwesomeFormatter = function(value) {
    if (value) {
        return '<i class="font-awesome fa ' + value + '"></i>';
    }
};
